import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@alfresco/adf-core';
import { DOCUMENT_LIST_DIRECTIVES } from '@alfresco/adf-content-services';

import { WkDocumentListComponent } from './wk-document-list.component';
import { WkDocumentListDirective } from '../../directives/wk-document-list.directive';

@NgModule({
  imports: [CommonModule, CoreModule, ...DOCUMENT_LIST_DIRECTIVES],
  declarations: [WkDocumentListComponent, WkDocumentListDirective],
  exports: [WkDocumentListComponent, WkDocumentListDirective],
})
export class WkDocumentListModule {}
